import React from 'react';
import cn from 'classnames';

import ICON_ARROW from 'assets/images/arrow-down@3x.png';
import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { formatDayToShortYearOrdinal } from 'utils/date/format.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

import AllServicesDropDown from 'clientCommunications/components/Clients/common/AllServicesDropDown.component';
import AllStylistDropDown from 'clientCommunications/components/Clients/common/AllStylistDropDown.component';
import LastVisit from 'clientCommunications/components/Clients/common/LastVisitDropDown.component';
import Loyalty from 'clientCommunications/components/Clients/common/LoyaltyDropDown';
import NextVisit from 'clientCommunications/components/Clients/common/NextVisitDropDown.component';
import TimeRange from 'clientCommunications/components/Clients/common/TimeRangeDropDown';
const L = logger('ClientFilterBar');

const fromServicesToCount = (services) => {
  const array = [];
  for (const category of services) {
    array.push(category);
    for (const service of category.services) {
      array.push(service);
    }
  }
  return array.length;
};

const formatDisplayDate = (date) => (isDateWorthy(date) ? formatDayToShortYearOrdinal(date) : '');

// FIXME: improve all - js css html
class ClientFilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLastVisit: '',
      currentNextVisit: '',
      filterServiceList: [],
      filterStylistList: [],
      totalServicesNumber: fromServicesToCount(this.props.services),
      selectedNoVisit: false,
      selectedWeekAgo: false,
    };
  }

  componentWillUnmount() {
    this.onClearFilters();
  }

  onCheckLatVisit = (option) => void this.setState({ currentLastVisit: option });
  onCheckNoVisit = () => void this.setState({ selectedNoVisit: !this.state.selectedNoVisit });
  onCheckWeekAgo = () => void this.setState({ selectedWeekAgo: !this.state.selectedWeekAgo });
  onCheckNextVisit = (option) => void this.setState({ currentNextVisit: option });

  // FIXME: check if this duplicate or the following one is the correct
  // noinspection JSUnusedGlobalSymbols
  onClearLastVisitSelectionDuplicate = () => {
    this.props.filterLastVisit('');
    this.setState({ currentLastVisit: '' });
  };

  onClearLastVisitSelection = () => {
    this.props.filterLastVisit('');
    this.setState({ currentLastVisit: '' });
    this.openDropDown('lastVisit', true);
  };

  onDoneLastVisit = () => {
    this.props.filterLastVisit(this.state.currentLastVisit);
    this.openDropDown('lastVisit', true);

    this.setState({ currentLastVisit: '' });
    this.props.trackEvent(`lastvisit_${this.state.currentLastVisit}`);
  };

  onClearNextVisitSelection = () => {
    this.props.filterNextVisit('');
    this.setState({ currentNextVisit: '' });
    this.openDropDown('nextVisit', true);
  };

  onDoneLoyalty = (isAnyAmount, amount, isAnyNumber, number) => {
    // Loyalty functionality
    this.props.filterLoyalty(isAnyAmount, amount, isAnyNumber, number);

    this.openDropDown('loyalty', true);
    this.props.trackEvent(`loyalty_${this.state.currentLastVisit}`);
  };

  onDoneNextVisit = () => {
    this.props.filterNextVisit(this.state.currentNextVisit);
    this.openDropDown('nextVisit', true);

    this.setState({ currentNextVisit: '' });
    this.props.trackEvent(`nextvisit_${this.state.currentLastVisit}`);
  };

  onClearFilters = () => {
    this.props.getClientsCalculatedList(this.props.salonId, this.props.bucketType);
    this.setState({ filterStylistList: [] });
    this.setState({ filterServiceList: [] });
    this.setState({ currentNextVisit: '' });
    this.setState({ currentLastVisit: '' });
    this.props.clearLastDatesSelected();
    this.props.trackEvent('clear_filters');
  };

  onDoneSelectTime = () => {
    this.props.filterData(
      this.props.salonId,
      this.props.bucketType,
      this.state.filterStylistList,
      this.state.filterServiceList,
    );
    setTimeout(() => {
      this.props.filterTimeRange();
    }, 100);
    this.openDropDown('timeRange', true);
  };

  onSelectAllService = (selectAll) => {
    const listAll = [];
    if (selectAll) {
      this.props.services.forEach((category) => {
        listAll.push(category);
        category.services.forEach((s) => {
          listAll.push(s);
        });
      });
    }
    this.setState({ filterServiceList: listAll });
    this.props.trackEvent('filter_all_services');
  };

  onSelectServiceItem = (service) => {
    let servicesCategoriesFlatList = this.state.filterServiceList.length < 1 ? [] : [...this.state.filterServiceList];

    const existInList = servicesCategoriesFlatList.filter((c) => c.id === service.id);
    if (existInList.length > 0) {
      servicesCategoriesFlatList = servicesCategoriesFlatList.filter((c) => c.id !== service.id);
      if (service.services) {
        service.services.forEach((s) => {
          servicesCategoriesFlatList = servicesCategoriesFlatList.filter((c) => c.id !== s.id);
        });
      }
    } else {
      servicesCategoriesFlatList.push(service);
      if (service.services) {
        service.services.forEach((selService) => servicesCategoriesFlatList.push(selService));
      }
    }

    this.setState({ filterServiceList: servicesCategoriesFlatList });
    this.props.trackEvent('filter_services');
  };

  onSelectStylist = (stylistId) => {
    let modifiedList = this.state.filterStylistList.length < 1 ? [] : [...this.state.filterStylistList];

    const existInList = modifiedList.filter((c) => c === stylistId);
    if (existInList.length > 0) {
      modifiedList = modifiedList.filter((c) => c !== stylistId);
    } else {
      modifiedList.push(stylistId);
    }

    this.setState({ filterStylistList: modifiedList });
    this.props.trackEvent('filter_stylists');
  };

  onSelectAllStylists = (selectAll) => {
    const listOfAll = [];
    if (selectAll) {
      this.props.stylists.forEach((i) => listOfAll.push(i.id));
    }
    this.setState({ filterStylistList: listOfAll });
    this.props.trackEvent('filter_all_stylists');
  };

  clearLastDatesSelected = () => {
    this.props.clearLastDatesSelected();
    this.openDropDown('timeRange', true);
    this.props.filterData(
      this.props.salonId,
      this.props.bucketType,
      this.state.filterStylistList,
      this.state.filterServiceList,
    );
  };

  openDropDown = (filter, close) => {
    if (filter !== 'timeRange' && close) {
      this.props.filterData(
        this.props.salonId,
        this.props.bucketType,
        this.state.filterStylistList,
        this.state.filterServiceList,
      );
    }
    this.props.openDropdown(filter);
  };

  closeFilter = () => {
    if (this.props.isStylistOpen) {
      this.openDropDown('stylist', false);
    } else if (this.props.isServiceOpen) {
      this.openDropDown('service', false);
    } else if (this.props.isLastVisit) {
      this.openDropDown('lastVisit', false);
    } else if (this.props.isNextVisit) {
      this.openDropDown('nextVisit', false);
    } else if (this.props.isTimeRange) {
      this.openDropDown('timeRange', false);
    } else if (this.props.isLoyalty) {
      this.openDropDown('loyalty', false);
    }
  };

  render() {
    const selectedLastVisit = this.props.selectedLastVisit;
    const lastDatesSelected = this.props.lastDatesSelected;
    const selectedNextVisit = this.props.selectedNextVisit;
    const setDatePickerDate = this.props.setTimeRange;
    const stylists = this.props.stylists;

    const filterStylistList = this.state.filterStylistList;
    const filterServiceList = this.state.filterServiceList;

    const filterStylistListLength = filterStylistList.length;
    const filterServiceListLength = filterServiceList.length;

    L.debug('render()', { lastDatesSelected });

    let stylistClass = '';
    let stylistLabel = 'Staff     ';
    if (filterStylistListLength > 0 && filterStylistListLength !== stylists.length) {
      stylistClass = 'selected';
      stylistLabel = filterStylistListLength.toString().concat(' ', 'Staff   ');
    } else if (filterStylistListLength === stylists.length) {
      stylistClass = 'selected';
      stylistLabel = 'All Staff  ';
    }

    const selectAll = filterServiceList ? [...filterServiceList] : [];

    let serviceClass = '';
    let serviceLabel = 'Services     ';
    if (filterServiceListLength > 0) {
      if (filterServiceListLength !== this.state.totalServicesNumber) {
        const onlyCountService = this.props.selectedServices.filter((c) => !c.services).length;
        serviceClass = 'selected';
        if (onlyCountService === 1) {
          serviceLabel = onlyCountService.toString().concat(' ', 'Service');
        } else {
          serviceLabel = onlyCountService.toString().concat(' ', 'Services');
        }
      } else if (filterServiceListLength === this.state.totalServicesNumber) {
        serviceClass = 'selected';
        serviceLabel = 'All Services   ';
      }
    }

    let lastVisitClass = '';
    let lastVisitLabel = 'Last Visit   ';
    if (selectedLastVisit) {
      lastVisitClass = 'selected';
      if (selectedLastVisit === '>7days') {
        lastVisitLabel = 'Last 7 Days';
      }
      if (selectedLastVisit === 'noVisit') {
        lastVisitLabel = 'No visits';
      }
      if (selectedLastVisit === '<1year') {
        lastVisitLabel = '1 Year    ';
      }
      if (parseInt(selectedLastVisit, 10)) {
        lastVisitLabel = `> ${selectedLastVisit} Weeks`;
      }
    }

    let nextVisitClass = '';
    let nextVisitLabel = 'Next Visit   ';
    if (selectedNextVisit) {
      nextVisitClass = 'selected';
      if (selectedNextVisit === 'anyDate') {
        nextVisitLabel = 'Any Future';
      }
      if (selectedNextVisit === 'next7days') {
        nextVisitLabel = 'Next 7 Days';
      }
      if (selectedNextVisit === 'noFuture') {
        nextVisitLabel = 'No Future';
      }
    }

    let nextVisitValue = selectedNextVisit;
    if (this.state.currentNextVisit) {
      nextVisitValue = this.state.currentNextVisit;
    }

    let lastVisitValue = selectedLastVisit;
    if (this.state.currentLastVisit) {
      lastVisitValue = this.state.currentLastVisit;
    }

    let timeRangeClass = '';
    let timeRangeLabel;

    if (!lastDatesSelected) {
      timeRangeLabel = 'Date Range ';
    } else if (lastDatesSelected.toDate) {
      timeRangeLabel = `${formatDisplayDate(lastDatesSelected?.fromDate)}
      - ${formatDisplayDate(lastDatesSelected?.toDate)}`;
    } else {
      timeRangeLabel = `${formatDisplayDate(lastDatesSelected?.fromDate)}
      - ${formatDisplayDate(lastDatesSelected?.fromDate)}`;
    }
    if (lastDatesSelected) {
      timeRangeClass = 'selected time-range';
    }
    // gt: '>',
    // lt: '<',
    let loyaltyClass = '';
    let loyaltyLabel = 'Loyalty';
    if (this.props.selectedLoyalty) {
      if (this.props.selectedLoyalty.isAnyAmount === true) {
        loyaltyClass = 'selected';
        loyaltyLabel = (
          <div>
            {S.gt}
            <CurrencySign />
            {this.props.selectedLoyalty.amount.toString()} Spend
          </div>
        );
      }
      if (this.props.selectedLoyalty.number > 0) {
        loyaltyClass = 'selected';
        if (loyaltyLabel === 'Loyalty') {
          loyaltyLabel = (
            <div>
              {S.gt}
              {this.props.selectedLoyalty.number.toString()} Visits
            </div>
          );
        } else if (this.props.selectedLoyalty.isAnyAmount === true) {
          loyaltyLabel = 'Spend, Visits ';
        }
      }
    }

    const isOverlayVisible =
      this.props.isStylistOpen ||
      this.props.isServiceOpen ||
      this.props.isLastVisit ||
      this.props.isNextVisit ||
      this.props.isTimeRange ||
      this.props.isLoyalty;

    return (
      <div data-bem="ClientFilterBar" className="client-filter-bar">
        <div className="filter-sub-nav">
          <div className="filter-sub-nav-buttons">
            <div
              role="button"
              tabIndex={0}
              onClick={this.closeFilter}
              className={`close-filter-overlay ${isOverlayVisible ? 'show' : 'hide'}`}
            />
            <div className="filter-sub-title">
              <h5 className="main">Filters</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('stylist', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isStylistOpen,
                selected: stylistClass,
              })}
            >
              <span className="span-txt">{stylistLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>AND</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('service', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isServiceOpen,
                selected: serviceClass,
              })}
            >
              <span>{serviceLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>AND</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('lastVisit', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isLastVisit,
                selected: lastVisitClass,
              })}
            >
              <span>{lastVisitLabel}</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>AND</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('nextVisit', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isNextVisit,
                selected: nextVisitClass,
              })}
            >
              <span>{nextVisitLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>AND</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('timeRange', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isTimeRange,
                selected: timeRangeClass,
              })}
            >
              <span>{timeRangeLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div className="filter-sub-title">
              <h5>AND</h5>
            </div>
            <div
              id="menuItemID"
              onClick={() => {
                this.openDropDown('loyalty', false);
              }}
              className={cn({
                filterButton: true,
                opened: this.props.isLoyalty,
                selected: loyaltyClass,
              })}
            >
              <span>{loyaltyLabel} &nbsp;</span>
              <img src={ICON_ARROW} alt="" />
            </div>
            <div
              className="clear-filter"
              role="button"
              onClick={() => {
                this.onClearFilters();
              }}
              tabIndex="-1"
            >
              <span>Clear filters</span>
            </div>
          </div>
        </div>
        <AllStylistDropDown
          isStylistOpen={this.props.isStylistOpen}
          selectedStylistIds={filterStylistList}
          stylists={stylists}
          onFilterStylist={this.props.filterStylist}
          onSelectStylist={this.onSelectStylist}
          onSelectAllStylists={this.onSelectAllStylists}
          closeStylistDropDown={() => {
            this.openDropDown('stylist', true);
          }}
        />
        <AllServicesDropDown
          services={this.props.services}
          isServiceOpen={this.props.isServiceOpen}
          selectedServices={selectAll}
          filterService={this.props.filterService}
          totalServicesNumber={this.state.totalServicesNumber}
          onSelectAllService={this.onSelectAllService}
          onSelectServiceItem={this.onSelectServiceItem}
          closeServiceDropDown={() => {
            this.openDropDown('service', true);
          }}
        />
        <LastVisit
          isLastVisit={this.props.isLastVisit}
          selectedLastVisit={lastVisitValue}
          selectedNoVisit={this.state.selectedNoVisit}
          selectedWeekAgo={this.state.selectedWeekAgo}
          onClearLastVisitSelection={this.onClearLastVisitSelection}
          onCheckLatVisit={this.onCheckLatVisit}
          onDoneLastVisit={this.onDoneLastVisit}
          onCheckNoVisit={this.onCheckNoVisit}
          onSelectDropdownVisit={alwaysNoop}
          onCheckWeekAgo={this.onCheckWeekAgo}
        />
        <NextVisit
          isNextVisit={this.props.isNextVisit}
          selectedNextVisit={nextVisitValue}
          onCheckNextVisit={this.onCheckNextVisit}
          onClearNextVisitSelection={this.onClearNextVisitSelection}
          onDoneNextVisit={this.onDoneNextVisit}
        />
        <Loyalty
          isLoyalty={this.props.isLoyalty}
          selectedLoyalty={this.props.selectedLoyalty}
          onDoneLoyalty={this.onDoneLoyalty}
        />
        <TimeRange
          isTimeRange={this.props.isTimeRange}
          onDoneSelectTime={this.onDoneSelectTime}
          setDatePickerDate={setDatePickerDate}
          clearLastDatesSelected={this.clearLastDatesSelected}
          lastDatesSelected={lastDatesSelected}
        />
      </div>
    );
  }
}

export default ClientFilterBar;
